// extracted by mini-css-extract-plugin
export default {"uploader":"ImageUploader_uploader__UvuOY","box":"ImageUploader_box__GIsdc","tip":"ImageUploader_tip__W6KQ8"};